import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  min-height: 100vh;
  background: #0B1122;
  color: white;
  padding: 2.5rem;
`;

const BackButton = styled.button`
  font-size: 0.875rem;
  color: #5ce9ff;
  background: none;
  border: none;
  cursor: pointer;
  margin-bottom: 1.5rem;
  padding: 0;
  
  &:hover {
    text-decoration: underline;
  }
`;

const AuctionTitle = styled.h1`
  font-size: 1.875rem;
  font-weight: 600;
  margin-top: 1.5rem;
  margin-bottom: 0;
`;

const AuctionMeta = styled.p`
  color: #9ca3af;
  margin-bottom: 1.5rem;
`;

const TiersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const TierCard = styled.div`
  padding: 1rem;
  border-radius: 0.75rem;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const JoinButton = styled.button`
  margin-top: 1.5rem;
  padding: 0.75rem 1.5rem;
  border-radius: 0.75rem;
  background: linear-gradient(to right, #00f7d2, #5ce9ff);
  border: none;
  color: black;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.2s;
  
  &:hover {
    opacity: 0.9;
  }
`;

const AuctionView = ({ auction, onBack }) => {
  return (
    <PageContainer>
      <BackButton onClick={onBack}>← Back to Store</BackButton>
      <AuctionTitle>{auction.title}</AuctionTitle>
      <AuctionMeta>Ends in {auction.endsIn}</AuctionMeta>
      <TiersContainer>
        {auction.tiers?.map((tier, i) => (
          <TierCard key={i}>
            <span>{tier.qty}+ units</span>
            <span>€{tier.price} / unit</span>
          </TierCard>
        ))}
      </TiersContainer>
      <JoinButton>Join Auction</JoinButton>
    </PageContainer>
  );
};

export default AuctionView;
